import type { Reducer } from 'redux';
import { combineReducers } from 'redux';

import campaigns from './campaigns/reducer';
import events from './events/reducer';
import groups from './groups/reducer';
import myLeaders from './myLeaders/reducer';
import teamsMeetings from './teamsMeetings/reducer';
import type { PinnedThreads } from './types';
import userStorylines from './userStorylines/reducer';

const reducer: Reducer<PinnedThreads> = combineReducers<PinnedThreads>({
  campaigns,
  events,
  groups,
  myLeaders,
  teamsMeetings,
  userStorylines,
});

export default reducer;
